import React from 'react';
import { motion } from 'framer-motion';
import { MoonStar, AlertCircle } from 'lucide-react';
export function Problem() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-205">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="bg-white rounded-3xl p-8 md:p-12 shadow-soft relative overflow-hidden" data-id="element-206">
        <div className="absolute top-0 right-0 w-64 h-64 bg-brand-blue/5 rounded-bl-full -z-0" data-id="element-207"></div>

        <div className="relative z-10" data-id="element-208">
          <div className="flex items-center gap-3 mb-6 text-brand-dark" data-id="element-209">
            <MoonStar className="text-brand-blue" size={28} data-id="element-210" />
            <h2 className="text-2xl md:text-3xl font-bold" data-id="element-211">
              Imagina que es domingo por la noche...
            </h2>
          </div>

          <p className="text-lg text-brand-text mb-6 leading-relaxed" data-id="element-212">
            Tu hijo tiene una tarea difícil y te pide ayuda. Notas que el texto
            que te enseña suena{' '}
            <span className="italic font-medium" data-id="element-213">"demasiado perfecto"</span>.
            ¿Lo escribió él o lo hizo una máquina? ¿Es trampa o es eficiencia?
          </p>

          <div className="bg-cream-100 rounded-2xl p-6 border border-cream-200" data-id="element-214">
            <div className="flex items-start gap-4" data-id="element-215">
              <div className="bg-brand-orange/10 p-2 rounded-full shrink-0 mt-1" data-id="element-216">
                <AlertCircle className="text-brand-orange" size={24} data-id="element-217" />
              </div>
              <div data-id="element-218">
                <p className="text-brand-dark font-medium mb-2" data-id="element-219">
                  El dolor no es la tecnología; es la pérdida de autoridad y
                  conexión.
                </p>
                <p className="text-brand-text" data-id="element-220">
                  El miedo a que la IA vuelva "flojos" a los niños es válido,
                  pero prohibirla solo los aleja de ti. El verdadero peligro no
                  es que ellos la usen, sino que tú no sepas cómo guiarlos para
                  que la usen con ética y criterio.
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}